import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import {
    Chart,
    BarSeries,
    ArgumentAxis,
    ValueAxis,
    LineSeries,
    ScatterSeries,
    Tooltip
} from '@devexpress/dx-react-chart-material-ui';

import { Animation, EventTracker } from '@devexpress/dx-react-chart';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { easeBounceOut } from 'd3-ease';


export default function ProgressionChart(props) {
    const classes = useStyles();

    const [chartData, setChartData] = useState([])


    useEffect(() => {
        //add last bar with totalAmount so that the chart shows the full Y-Axis 
        let amountToProcess = props.progressions.find(x => x.workstationId === props.workstation.id).amountToProcess
        let progression = props.progressions.find(x => x.workstationId === props.workstation.id).progression
        if (!progression.some(x => x.time === "")) {
            progression.push({ time: "", value: amountToProcess })
        }

        //add shouldProcessedAmount for the trendLine => shift is 8 hours => totalAmount/8 per hour should be processed
        var i;
        for (i = 0; i < progression.length - 1; i++) {
            progression[i]['milestoneAmount'] = (amountToProcess / 16) * (i + 7)
            if (i === progression.length - 2) {
                progression[i]['endPoint'] = (amountToProcess / 16) * (i + 7)
            }
        }

        setChartData(progression)
    }, [props.workstation, props.progressions]);

    let numberOfSteps = props.progressions.find(x => x.workstationId === props.workstation.id).progression.length

    const getPath = (x, width, y, y1) =>

        `M ${x} ${y1 - 0.5}
        L ${width + x} ${y1 - 0.5}
        L ${width + x} ${y + 8}
        q0,-8 -8,-8   
        L ${x + width - 8} ${y}
        L ${x + 8} ${y}
        q-8,0 -8,8 
        Z`;

  

    const BarWithLabel = ({
        arg, barWidth, maxBarWidth, val, startVal, color, value, style, argument
    }) => {
        const width = maxBarWidth * barWidth;
        return (chartData[chartData.length - 2].time !== argument ?
            <React.Fragment>
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="5%" stopColor={FlagstoneTheme.palette.primary.main} />
                        <stop offset="95%" stopColor="white" />
                    </linearGradient>
                </defs>
                <path d={getPath(arg - width / 2, width, val, startVal)} style={style} fill="url(#gradient)" />
            </React.Fragment> :
            <React.Fragment>
                <defs>
                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="5%" stopColor="#A8A8A8" />
                        <stop offset="95%" stopColor="white" />
                    </linearGradient>
                </defs>
                <path d={getPath(arg - width / 2, width, val, startVal)} style={style} fill="url(#gradient1)" />
            </React.Fragment>
        );
    };

    const lineComponent = props =>
        <React.Fragment>
            <LineSeries.Path {...props}
                strokeDasharray="4,3"
                color="black"
            >
            </LineSeries.Path>
        </React.Fragment>

    return (
        <div className={classes.progressionChart}>
            <div className={classes.title}>
                Progression
            </div>
            <Chart className={classes.chart}
                data={chartData}
            >
                <ArgumentAxis />
                <ValueAxis max={numberOfSteps} />
                <BarSeries
                    name="barSeries"
                    valueField="value"
                    argumentField="time"
                    style={{ width: "3%" }}
                    pointComponent={BarWithLabel}                    
                />
                <EventTracker />
                <Tooltip/>
                <ScatterSeries
                    valueField="endPoint"
                    argumentField="time"
                    color="black"
                />
                <LineSeries
                    name="progress"
                    valueField="milestoneAmount"
                    argumentField="time"
                    seriesComponent={lineComponent}
                />

                <Animation duration={2000} easing={easeBounceOut} />
            </Chart>

        </div>
    )
}

const useStyles = makeStyles(() => ({
    chart: {
        height: "400px !important",
        width: "111%",
    },
    title: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginBottom: "10px"
    },
    chartLabel: {
        width: "50px",
        height: "20px",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        position: "relative",
        right: "2%"
    },
    progressionChart: {
        height: "400px",
        padding: "20px",
        backgroundColor: "white",
        borderRadius: "6px",
        marginBottom: "10px",
        paddingBottom: "40px",
        overflow: "hidden",
        paddingRight: "0px",
        borderRight: "40px solid white",

    },
}));